module.exports = __webpack_public_path__ + "static/media/tif.8cd460ca.svg";